import React from 'react';
import styled from 'styled-components';

import Container from 'components/Container';
import Row from 'components/Row';
import Stack from 'components/Stack';
import Text from 'components/Text';

import CrvLogo from 'images/team/investors/crv-logo.svg?svgr';
import FelicisLogo from 'images/team/investors/felicis-logo.svg?svgr';
import MenloLogo from 'images/team/investors/menlo-ventures-logo.svg?svgr';

const Section = styled.section`
  padding: 4.5rem 1rem;
  position: relative;
  text-align: center;
`;

const Investors = styled(Row)`
  width: 100%;
  max-width: 30rem;
`;

const InvestorLogo = styled.svg`
  max-height: 12.5vw;
`;

export default function OurInvestors() {
  return (
    <Section>
      <Container as={Stack} size="sm" gap="3.5rem" align="center">
        <Stack gap="2.25rem">
          <Text as="h2" variant="heading.section">
            Our Investors
          </Text>
          <Text variant="md">
            We are fortunate to partner with leading venture capital firms who
            truly understand the unique nuances of the developer-first space,
            with the track record of backing early stage developer tools
            startups that have gone on to achieve incredible success.
          </Text>
        </Stack>
        <Investors
          colGap="1rem"
          rowGap="1.5rem"
          align="stretch"
          breakpoint="md"
          layout="fixed"
        >
          <InvestorLogo as={MenloLogo} fill="#728293" height="80" width="150" />
          <InvestorLogo as={CrvLogo} fill="#728293" height="80" width="150" />
          <InvestorLogo
            as={FelicisLogo}
            fill="#728293"
            height="80"
            width="150"
          />
        </Investors>
      </Container>
    </Section>
  );
}
